import React from "react"
import styles from "./RegisterGoogleDetail.module.css"
import { RegisterGoogleDetailProps } from "./types"
import { useGtm } from '../../../../../../../hooks/useGtm'

export default function RegisterGoogleDetail({
    reasonPoint1Images,
    signupPath,
}: RegisterGoogleDetailProps) {
    const signupUrl = `/${signupPath || "signup?channel=googleadwords"}`

    useGtm(['GTM-MJ9GMNND', 'GTM-PZVGNPT'])

    return (
        <div className={styles.container}>
            <div className={styles.firstView}>
                <header>
                    <img
                        className={styles.firstViewPc}
                        src={`/pages/google/Common/Foodslabo/Detail/logo_white.png`}
                        alt="FoodsLabo"
                    />
                </header>
                <div className={styles.firstViewBox}>
                    <img
                        className={styles.firstViewPc}
                        src={`/pages/google/Common/Foodslabo/Detail/first_view_pc.png`}
                        alt=""
                    />
                    <img
                        className={styles.firstViewTopSp}
                        src={`/pages/google/Common/Foodslabo/Detail/first_view_top_sp.jpg`}
                        alt=""
                    />
                </div>
            </div>

            <div className={styles.firstViewBottomSp}>
                <img
                    src={`/pages/google/Common/Foodslabo/Detail/first_view_bottom_sp.png`}
                    alt=""
                />
            </div>

            <div className={`${styles.entryCta} ${styles.entryCtaFirstView}`}>
                <a
                    className={styles.entryCtaA}
                    href={signupUrl}
                >
                    無料登録して求人を見る
                </a>
            </div>

            <section id="reason" className={styles.reason}>
                <h1>
                    <img
                        src={`/pages/google/Common/Foodslabo/Detail/reason_h1.png`}
                        alt="FoodLaboが選ばれる4つの理由"
                    />
                </h1>

                <div className={styles.reasonPoint1}>
                    <h2>
                        <img
                            src={`/pages/google/Common/Foodslabo/Detail/reason_point1_h1.png`}
                            alt="POINT1 FoodsLaboだけの限定求人"
                        />
                    </h2>
                    <div className={styles.reasonPoint1Box}>
                        {reasonPoint1Images.map((image, index) => (
                            <img key={index} src={image.src} alt={image.alt} />
                        ))}
                    </div>
                    <div className={styles.reasonPoint1CompanyLogo}>
                        <img
                            src={`/pages/google/Common/Foodslabo/Detail/reason_point1_company_logo.png`}
                            alt=""
                        />
                    </div>
                    <div className={styles.entryCta}>
                        <a
                            className={styles.entryCtaA}
                            href={signupUrl}
                        >
                            無料登録して求人を見る
                        </a>
                    </div>
                    <img
                        className={styles.reasonPoint1Voice}
                        src={`/pages/google/Common/Foodslabo/Detail/reason_point1_voice.png`}
                        alt=""
                    />
                </div>

                <div className={styles.reasonPoint2}>
                    <ul className={styles.reasonPoint2Box}>
                        <li className={styles.reasonPoint2Box1}>
                            <img
                                className={styles.reasonPoint2H1Pc}
                                src={`/pages/google/Common/Foodslabo/Detail/reason_point2_h1_pc.png`}
                                alt="無料のエージェントサポート"
                            />
                            <img
                                className={styles.reasonPoint2H1Sp}
                                src={`/pages/google/Common/Foodslabo/Detail/reason_point2_h1_sp.png`}
                                alt="無料のエージェントサポート"
                            />
                            <div
                                className={`${styles.entryCta} ${styles.entryCtaReasonPoint2_1}`}
                            >
                                <a
                                    className={styles.entryCtaA}
                                    href={signupUrl}
                                >
                                    無料登録してサポートを受ける
                                </a>
                            </div>
                        </li>
                        <li className={styles.reasonPoint2Box2}>
                            <img
                                className={styles.reasonPoint2ImagePc}
                                src={`/pages/google/Common/Foodslabo/Detail/reason_point2_image_pc.png`}
                                alt=""
                            />
                            <img
                                className={styles.reasonPoint2ImageSp}
                                src={`/pages/google/Common/Foodslabo/Detail/reason_point2_image_sp.png`}
                                alt=""
                            />
                        </li>
                    </ul>
                    <div className={styles.reasonPoint2Voice}>
                        <img
                            src={`/pages/google/Common/Foodslabo/Detail/reason_point2_voice.png`}
                            alt=""
                        />
                    </div>
                    <div
                        className={`${styles.entryCta} ${styles.entryCtaReasonPoint2_2}`}
                    >
                        <a
                            className={styles.entryCtaA}
                            href={signupUrl}
                        >
                            無料登録してサポートを受ける
                        </a>
                    </div>
                </div>

                <div className={styles.reasonPoint3}>
                    <div className={styles.reasonPoint3BoxPc}>
                        <img
                            src={`/pages/google/Common/Foodslabo/Detail/reason_point3_image_scout_pc.png`}
                            alt="登録するだけでスカウトが届く"
                        />
                        <img
                            src={`/pages/google/Common/Foodslabo/Detail/reason_point3_image_aitai_pc.png`}
                            alt="気になっていた飲食店からあいたいが届く"
                        />
                    </div>
                    <div className={styles.reasonPoint3BoxSp}>
                        <h2 className={styles.reasonPoint3TitleScoutSp}>
                            <img
                                src={`/pages/google/Common/Foodslabo/Detail/reason_point3_title_scout_sp.png`}
                                alt=""
                            />
                        </h2>
                        <figure>
                            <img
                                src={`/pages/google/Common/Foodslabo/Detail/reason_point3_image_scout_sp.png`}
                                alt=""
                            />
                        </figure>
                        <h2 className={styles.reasonPoint3TitleAitaiSp}>
                            <img
                                src={`/pages/google/Common/Foodslabo/Detail/reason_point3_title_aitai_sp.png`}
                                alt=""
                            />
                        </h2>
                        <figure>
                            <img
                                src={`/pages/google/Common/Foodslabo/Detail/reason_point3_image_aitai_sp.png`}
                                alt=""
                            />
                        </figure>
                    </div>
                    <div
                        className={`${styles.entryCta} ${styles.entryCtaReasonPoint3}`}
                    >
                        <a
                            className={styles.entryCtaA}
                            href={signupUrl}
                        >
                            スカウト/あいたいを受け取る
                        </a>
                    </div>
                </div>

                <div className={styles.reasonPoint4}>
                    <div className={styles.reasonPoint4BoxPc}>
                        <h2>
                            <img
                                src={`/pages/google/Common/Foodslabo/Detail/reason_point4_title_pc.png`}
                                alt=""
                            />
                        </h2>
                        <figure>
                            <img
                                src={`/pages/google/Common/Foodslabo/Detail/reason_point4_image_pc.png`}
                                alt=""
                            />
                        </figure>
                    </div>
                    <div className={styles.reasonPoint4BoxSp}>
                        <h2>
                            <img
                                src={`/pages/google/Common/Foodslabo/Detail/reason_point4_title_sp.png`}
                                alt=""
                            />
                        </h2>
                        <figure className={styles.reasonPoint4ImageSp}>
                            <img
                                src={`/pages/google/Common/Foodslabo/Detail/reason_point4_image_sp.png`}
                                alt=""
                            />
                        </figure>
                        <figure className={styles.reasonPoint4VoiceSp}>
                            <img
                                src={`/pages/google/Common/Foodslabo/Detail/reason_point4_voice_sp.png`}
                                alt=""
                            />
                        </figure>
                        <div className={styles.entryCta}>
                            <a
                                className={styles.entryCtaA}
                                href={signupUrl}
                            >
                                無料登録して求人に応募してみる
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <section
                id="after_registration"
                className={styles.afterRegistration}
            >
                <h2>
                    <img
                        src={`/pages/google/Common/Foodslabo/Detail/after_h2.png`}
                        alt="登録後はどうするの？"
                    />
                </h2>
                <div className={styles.afterImagePc}>
                    <img
                        src={`/pages/google/Common/Foodslabo/Detail/after_image_pc.png`}
                        alt=""
                    />
                </div>
                <div className={styles.afterImageSp}>
                    <img
                        src={`/pages/google/Common/Foodslabo/Detail/after_image_sp.png`}
                        alt=""
                    />
                </div>
                <div className={styles.entryCta}>
                    <a
                        className={styles.entryCtaA}
                        href={signupUrl}
                    >
                        無料登録して求人を見る
                    </a>
                </div>
            </section>

            <section id="question" className={styles.question}>
                <h2>
                    <img
                        src={`/pages/google/Common/Foodslabo/Detail/question_h1.png`}
                        alt="よくある質問"
                    />
                </h2>
                <ul>
                    <li>
                        <img
                            src={`/pages/google/Common/Foodslabo/Detail/question_image_1.png`}
                            alt=""
                        />
                    </li>
                    <li>
                        <img
                            src={`/pages/google/Common/Foodslabo/Detail/question_image_2.png`}
                            alt=""
                        />
                    </li>
                    <li>
                        <img
                            src={`/pages/google/Common/Foodslabo/Detail/question_image_3.png`}
                            alt=""
                        />
                    </li>
                    <li>
                        <img
                            src={`/pages/google/Common/Foodslabo/Detail/question_image_4.png`}
                            alt=""
                        />
                    </li>
                </ul>
                <div className={styles.entryCta}>
                    <a
                        className={styles.entryCtaA}
                        href={signupUrl}
                    >
                        無料登録して求人を見る
                    </a>
                </div>
            </section>

            <section id="office" className={styles.office}>
                <div className={styles.officeInner}>
                    <h1>
                        <img
                            src={`/pages/google/Common/Foodslabo/Detail/office_h1.png`}
                            alt="拠点"
                        />
                    </h1>
                </div>
                <div className={styles.officeWidth}>
                    <div className={styles.officeFlex}>
                        <img
                            src={`/pages/google/Common/Foodslabo/Detail/office_img_1.png`}
                            alt="東京本社 東京都港区新橋1-10-6新橋M-SQUARE11F"
                        />
                        <img
                            src={`/pages/google/Common/Foodslabo/Detail/office_img_2.png`}
                            alt="関西支社 大阪府大阪市北区梅田2-4-9ブリーゼタワー17F"
                        />
                        <img
                            src={`/pages/google/Common/Foodslabo/Detail/office_img_3.png`}
                            alt="名古屋支社 愛知県名古屋市中村区名駅3丁目28-12大名古屋ビルヂング11階"
                        />
                        <img
                            src={`/pages/google/Common/Foodslabo/Detail/office_img_4.png`}
                            alt="福岡支社 福岡県福岡市博多区中洲5丁目3-8アクア博多5階"
                        />
                        <img
                            src={`/pages/google/Common/Foodslabo/Detail/office_img_5.png`}
                            alt="札幌支社 北海道札幌市中央区南1条西5丁目20郵政福祉札幌第一ビル4階"
                        />
                    </div>
                </div>
            </section>

            <div className={styles.afterVoice}>
                <img
                    src={`/pages/google/Common/Foodslabo/Detail/after_voice.png`}
                    alt=""
                />
            </div>

            <footer className={styles.footer}>
                <small>
                    Copyright &copy; {new Date().getFullYear()} foodsLabo by
                    cuolega All rights reserved.
                </small>
                <div>
                    <a href="https://cuolega.co.jp/privacy/">
                        プライバシーポリシー
                    </a>
                    <a href="https://cuolega.co.jp/terms/">利用規約</a>
                    <a href="https://cuolega.co.jp/profile/">会社概要</a>
                </div>
                <div className={styles.pMark}>
                    <img src="/pages/google/common/images/p-mark.png" alt="" />
                </div>
            </footer>
        </div>
    )
}
